import apiService from "./api";

const userService = {
    // Search user by ID
    searchUserById(userId) {
        return apiService.post('/user/search-user-by-id', { user_id: userId });
    },
    // Get current user info
    getCurrentUser() {
        return apiService.get('/user/me');
    },
    // Get user activation code
    getUserActivation(userId) {
        return apiService.get(`/user/${userId}/activation`);
    },
    // Get user QR hash
    getUserHash(userId) {
        return apiService.get(`/user/${userId}/hash`);
    },
    // Get user order history
    getUserHistory() {
        return apiService.get('/user/history');
    },
    // Get all guest users
    getAllGuestUsers() {
        return apiService.get('/user/get-all-guest-users');
    },
    // Update user menu permissions
    updateUserMenu(userId, menuItems) {
        return apiService.post('/user/user-menus-edit', {
            menu: menuItems,
            user_id: userId,
        });
    },
    // Update user settings visibility
    updateUserSettings(userId, settings) {
        return apiService.post('/user/can-see-settings', {
            settings: settings,
            user: { id: userId },
        });
    },
    updateUserSettingsV2(settings) {
        return apiService.post('/user/v2/can-see-settings', settings);
    },
    // Update user restaurant access
    updateUserRestaurantAccess(userId, hasAccess) {
        return apiService.post('/user/can-add-sub-restoran', {
            restoran: hasAccess,
            user: { id: userId },
        });
    },
    // Get user orders by month
    getOrdersByMonth(data) {
        return apiService.post('/user/orders-by-month', data);
    },
    // Get user food orders by month
    getFoodOrdersByMonth(data) {
        return apiService.post('/user/food-orders-by-month', data);
    },
    // Get more restaurants orders by month
    getMoreRestaurantsOrdersByMonth(data) {
        return apiService.post('/user/more-restaurants-orders-by-month', data);
    },
    // Send forgot password email
    sendForgotPasswordEmail(email) {
        return apiService.post('/user/forgot-password', { email });
    },
    // Reset password with token
    resetPassword(token, password) {
        return apiService.post('/user/reset-password', { token, password });
    },
    // Change user password
    changePassword(userId, oldPassword, newPassword) {
        return apiService.post('/user/change-password', {
            id: userId,
            old_password: oldPassword,
            new_password: newPassword,
        });
    },
    // Update user profile
    updateProfile(userId, profileData) {
        return apiService.post(`/user/edit-profile/${userId}`, { ...profileData, _method: 'patch' });
    },
    // Delete user profile
    deleteProfile(user) {
        return apiService.post('/user/obrisi-profil', { user });
    },
    // User login
    login(username, password) {
        return apiService.post('/user/login', { username, password });
    },
    // User login with hash (QR code)
    loginWithHash(secure) {
        return apiService.post('/user/login/hash', { secure });
    },
    // Add new user (registration)
    addNewUser(userData) {
        return apiService.post('/user/add-new-user', userData);
    },
    // Check if email exists
    checkEmail(email) {
        return apiService.post('/user/check-email', { email });
    },
    // Choose restaurant for user
    chooseRestaurant(userId, restaurantId) {
        return apiService.post('/choose-restaurant', {
            user_id: userId,
            restoran_id: restaurantId,
        });
    },
    // Delete guest user
    deleteGuestUser(user, index) {
        return apiService.post('/user/delete-guest-user', { user, index });
    },
    // Edit guest user
    editGuestUser(user, index) {
        return apiService.post('/user/edit-guest-user', { user, index });
    },
    // Change user phone
    changeUserPhone(user) {
        return apiService.post('/user/change-user-phone', { user });
    },
    // Add new user location
    addNewUserLocation(data) {
        return apiService.post('/user/add-new-user-location', data);
    },
    // Edit user location
    editUserLocation(data) {
        return apiService.post('/user/edit-user-location', data);
    },
    // Delete user location
    deleteLocation(address) {
        return apiService.post('/user/delete-location', address);
    },
    // Get user location
    getUserLocation(userId) {
        return apiService.post('/user/get-user-location', { user_id: userId });
    },
    // Add user location
    addUserLocation(data) {
        return apiService.post('/user/add-user-location', data);
    },
    // Get user with orders (for payment/naplata page)
    getUserWithOrders(userId, params) {
        return apiService.get(`/user/${userId}`, params);
    },
    // Get group user with orders
    getGroupUserWithOrders(userId, params) {
        return apiService.get(`/user/${userId}/group`, params);
    },
};

export default userService;